import React, { useEffect } from 'react';
import { Script } from 'gatsby';

import useIsWebViewFlow from '../../hooks/useIsWebViewFlow';

const DEFAULT_SECTION = 'salesgeneral';

declare global {
  interface Window {
    section?: string;
    lpSiteId?: string;
    lpTag?: {
      site: string;
      section: string[];
    };
  }
}

export interface WebMessagingProps {
  siteId?: string;
  section?: string;
}

export const WebMessaging: React.FC<WebMessagingProps> = ({
  siteId = '',
  section = DEFAULT_SECTION
}) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.section = section;
    window.lpSiteId = siteId;
  }, [siteId, section]);

  if (!siteId) return null;

  return (
    <Script
      id="web-messaging-chat"
      src="/web-messaging-config.js"
      strategy="idle"
    />
  );
};

const WebMessagingWrapper: React.FC<WebMessagingProps> = props => {
  const { isClient, isWebView, flow } = useIsWebViewFlow();
  if (!isClient || isWebView) return null;

  return <WebMessaging key={flow} {...props} />;
};

export default React.memo(WebMessagingWrapper);